import meta from './meta'
const staticContent = require('./static').default

export default {
  ...staticContent,
  meta
}
